import { useEffect, useState } from "react";
import { getAppModules } from "../api/appModuleService";

export const useAppModules = (trigger) => {
    const [appModules, setAppModules] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getAppModules()
        .then((res) => setAppModules(res.data))
        .finally(() => setLoading(false));
    }, [trigger]);

    return { appModules, loading, setAppModules };
};
